export default __webpack_public_path__ + "static/media/chickennuggets-wide@3x.a4284db8.jpg";